<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ contactDataInfoTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ contactDataInfoSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- email -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="email"
                            id="email"
                            maxlength="50"
                            name="email"
                            placeholder=""
                            (keyup)="onChangeEmail($event)"
                        />
                        <label class="input-label" for="email">{{ emailLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.email.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoEmail | translate }}</span>
                    </div>
                </div>
            </div>

            <!-- telephone -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="telephone"
                            id="telephone"
                            maxlength="9"
                            name="telephone"
                            placeholder=""
                            (keyup)="onChangeTelephone($event)"
                        />
                        <label class="input-label" for="telephone">{{ telephoneLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.telephone.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoTelephone | translate }}</span>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
